// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2VQ7G","content":"ManualTimeModal_content__3C-8-"};